import { CommentArrowLeftOutlineIcon } from './CommentArrowLeftOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 192F008B-D02E-4C2A-A43F-058A19E41D30
 * name comment-arrow-left-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-arrow-left-outline.svg
 * tags
 */
export const CommentPreviousOutlineIcon = CommentArrowLeftOutlineIcon;
export default CommentPreviousOutlineIcon